import React, { useRef } from "react";

import { CSSTransition } from 'react-transition-group';
import Link from "../../../components/Link";

import style from "./style.module.css";

export default function SubMenu({ subMenu = [], resetActive = () => { }, activeId, megaMenuId, type = "desktop" }) {

    const nodeRef = useRef(null);

    if (type === "desktop") {
        return (
            <CSSTransition
                in={activeId === megaMenuId ? true : false}
                timeout={300}
                classNames="item"
                className={`${style.megaMenu} ${style.dropMenu}`}
                nodeRef={nodeRef}
                unmountOnExit
            >
                <div>
                    {
                        subMenu.map((subMenu, sindex) => {
                            return (
                                <div key={`subMenuLink_${sindex}_${subMenu.label}`} className={`${style.subMenuItem}`}>
                                    <Link onClick={resetActive} className={style.subMenuItemLink} to={subMenu.url}>{subMenu.label}</Link>
                                </div>
                            )
                        })
                    }
                </div>
            </CSSTransition>
        )
    } else if (type === "mobile") {
        return (
            <div className={`${style.mobileMegaMenuColumn}`}>
                <div className={style.mobileMegaMenuListColumnInner}>
                    <div className={style.mobileMegaBody}>
                        {
                            subMenu.map((megaMenu, index) => {
                                return (
                                    <Link key={`mobileMegaMenuItem_${index}`} className={style.mobileMegaMenuItem} to={megaMenu.url}>
                                        {megaMenu.label}
                                    </Link>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    } else {
        return null;
    }
}